export default __webpack_public_path__ + "static/media/827px-Escudo-UdeA.svg.6d499dfb.png";